import * as yup from 'yup'
import helpers from 'helpers'

export const schemaSubscribeStepContractor = yup.object().shape({
  name: yup.string().when('kind', {
    is: helpers.people.isPerson,
    then: yup.string().required(),
  }),
  kind: yup.string().required(),
  cpf: yup
    .string()
    .cpf()
    .cpfAvailable({ kindRef: yup.ref('kind') })
    .when('kind', {
      is: helpers.people.isPerson,
      then: yup.string().required(),
    }),
  cnpj: yup
    .string()
    .cnpj()
    .when('kind', {
      is: helpers.people.isCompany,
      then: yup
        .string()
        .cnpjAvailable()
        .required(),
    }),
  phone: yup.string().required(),
  tradeName: yup.string(),
  companyName: yup.string().when('kind', {
    is: helpers.people.isCompany,
    then: yup.string().required(),
  }),
  password: yup
    .string()
    .required()
    .min(6),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'As senhas não são iguais')
    .required()
    .min(6),
  address: yup.object().shape({
    postalCode: yup.string().required(),
    city: yup.string().required(),
    neighborhood: yup.string().required(),
    state: yup.string().required(),
    street: yup.string().required(),
    number: yup.string().required(),
    complement: yup.string(),
  }),
})

export default schemaSubscribeStepContractor
